import { render } from "./qrcode.vue?vue&type=template&id=77490770"
import script from "./qrcode.vue?vue&type=script&lang=ts"
export * from "./qrcode.vue?vue&type=script&lang=ts"
script.render = render

export default script